// extracted by mini-css-extract-plugin
export default {"root":"SAaTsab2vBmILNhWRNgI"};